import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { slideOut } from '@shared/animations';
import { Logout } from '@shared/store/shared.actions';
import { routeNames } from '@shared/models';
import { UserProfile } from '@app/store/portal.actions';
import { PortalState } from '@app/store/portal.state';

@Component({
  selector: 'prp-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  animations: [slideOut],
})
export class HeaderMenuComponent {
  @Select(PortalState.userprofile)
  userprofile$: Observable<any>;

  constructor(private store: Store) {}

  logout() {
    this.store.dispatch(new Logout());
  }

  onClick() {
    this.store.dispatch(new Navigate([routeNames.portalBase, routeNames.impressum]));
  }

  toggleMenu() {
    this.store.dispatch(new UserProfile());
  }
}
